<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="d-flex form-heading title-section form-section">
              <p class="form-title text-center" style="font-size: 35px;">
                DISCLOSURE TO SURPLUS LINE INSURED
              <br>
                <strong> IMPORTANT NOTICE </strong>
              </p>

            </article>
            <article class="input-section">
              <div>
                <p class="mb-3 ca-sl-disclosure" align="left">
                    1. The insurance policy that you are applying to purchase is being
                  issued by an insurer that is not licensed by the State of California.
                  These companies are called “nonadmitted” or “surplus line”
                  insurers.</p>
                <p class="mb-3 ca-sl-disclosure" align="left">
                  2. The insurer is not subject to the financial solvency regulation
                  and enforcement that apply to California licensed insurers.</p>
                <p class="mb-3 ca-sl-disclosure" align="left">
                  3. The insurer does not participate in any of the insurance
                  guarantee funds created by California law. Therefore, these funds
                  will not pay your claims or protect your assets if the insurer becomes
                  insolvent and is unable to make payments as promised.</p>

                <p class="mb-3 ca-sl-disclosure" align="left">
                  4. The insurer should be licensed either as a foreign insurer in
                  another state in the United States or as a non-United States (alien)
                  insurer. You should ask questions of your insurance agent, broker, or
                  “surplus line” broker or contact the California Department of
                  Insurance at the toll-free number 1-800-927-4357 or internet website <a href="http://WWW.INSURANCE.CA.GOV" target="_blank">www.insurance.ca.gov</a>. Ask whether or not the insurer is licensed as
                  a foreign or non-United States (alien) insurer and for additional
                  information about the insurer. You may also visit the NAIC’s internet
                  website at <a href="http://WWW.NAIC.ORG" target="_blank">www.naic.org</a>. The NAIC—the National Association of
                  Insurance Commissioners—is the regulatory support organization
                  created and governed by the chief insurance regulators in the United
                  States.</p>
                <p class="mb-3 ca-sl-disclosure" align="left">
                  5. Foreign insurers should be licensed by a state in the United
                  States and you may contact that state’s department of insurance to
                  obtain more information about that insurer. You can find a link to
                  each state from this NAIC internet website:
                  <a href="HTTPS://NAIC.ORG/STATE_WEB_MAP.HTM" target="_blank">https://naic.org/state_web_map.htm</a>.</p>
                <p class="mb-3 ca-sl-disclosure" align="left">
                  6. For non-United States (alien) insurers, the insurer should be
                  licensed by a country outside of the United States and should be on
                  the NAIC’s International Insurers Department (IID) listing of
                  approved nonadmitted non-United States insurers. Ask your agent,
                  broker, or “surplus line” broker to obtain more information about
                  that insurer..</p>
                <p class="mb-3 ca-sl-disclosure" align="left">
                  7. California maintains a “List of Approved Surplus Line Insurers
                  (LASLI).” Ask your agent or broker if the insurer is on that list, or
                  view that list at the internet website of the California Department of
                  Insurance:
                  <a href="HTTP://WWW.INSURANCE.CA.GOV/01-CONSUMERS/120-COMPANY/07-
                  LASLI/LASLI.CFM" target="_blank">www.insurance.ca.gov/01-consumers/120-company/07-
                    lasli/lasli.cfm</a>.</p>
                <p class="mb-3 ca-sl-disclosure" align="left">
                  8. If you, as the applicant, required that the insurance policy you
                  have purchased be effective immediately, either because existing
                  coverage was going to lapse within two business days or because you
                  were required to have coverage within two business days, and you did
                  not receive this disclosure form and a request for your signature until
                  after coverage became effective, you have the right to cancel this
                  policy within five days of receiving this disclosure. If you cancel
                  coverage, the premium will be prorated and any broker’s fee charged
                  for this insurance will be returned to you.</p>
              </div>
            </article>
            <article class="form-heading form-section review-sign">
              <div class="row mr-0 ml-0" style="align-content: center">
                <div class="col-md-5">
                </div>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <label class="notice-form-date">Date:</label>
                    <input
                      id="date"
                      type="date"
                      class="orep-text-input notice-input text-center"
                      :value="formattedCurrentDate()"
                      disabled
                    >
                  </section>
                </div>
                <div class="col-md-5">
                </div>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <label class="notice-form-date">INSURED:</label>
                    <input
                      type="text"
                      class="orep-text-input notice-input"
                      placeholder="Type Your Name to Sign"
                      name="slDisclosureSignature"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      v-model="quote.slDisclosureSignature"
                    >
                  </section>
                </div>
              </div>
            <div class="input-section">
              <p>D‐1 (Effective January 1, 2020)</p>
            </div>
            </article>

          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'property-inspector-7'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-2')"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-3')"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-4')"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-5')" v-if="!state.signedInUser"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-6')"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-7')"               v-if="quote.applicantOrAssociateHasAnyOtherProfessionalLicense === 'true' && (checkServices('real estate agent') || checkServices('contractor') || checkServices('engineer') || checkServices('pest inspector'))"
              ></button>
              <span class="pagination-dots pagination-current"></span>
            </article>
            <button
              class="next-btn mont spaced text-uppercase"
              @click="formSubmit()"
              :disabled="!state.pageSlDisclosureIsValid"
              :class="{submitDisabled: !state.pageSlDisclosureIsValid}"
            >Submit</button>
          </section>
        </div>
      </div>
    </div>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Processing...</span>
    </div>

  </div>
</template>

<script>
  import $ from "jquery";
  import moment from 'moment';
  import { STATUS } from "../../utils/constants";

  export default {
    name: "property-inspector-6",
    data() {
      return {
        loading: false
      };
    },
    computed: {
      quote() {
        return this.$store.state.homeInspector.quote;
      },
      state() {
        return this.$store.state.homeInspector;
      },
      errorMsg() {
        return this.$store.state.homeInspector.errorMsg;
      }
    },
    watch: {
      errorMsg: {
        handler() {
          if (this.errorMsg) {
            this.loading = false;
            this.$notify({
              group: 'error',
              type: 'error',
              title: 'Error',
              text: this.errorMsg
            });
          }
        }
      }
    },
    methods: {
      navigateToPrev(route) {
        this.$router.push({
          name: route
        });
      },
      next(routeName) {
        this.$router.push({
          name: routeName
        });
      },
      checkServices(service) {
        return this.quote.applicantOrAssociateReportMode.includes(service);
      },
      validateBeforeSubmit() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.state.pageSlDisclosureIsValid = true;
            return;
          }
          this.state.pageSlDisclosureIsValid = false;
        });
      },

      formattedCurrentDate() {
        return moment(this.quote.applicantPrincipleEsignatureDatetime).format('YYYY-MM-DD');
      },
      formSubmit() {
        this.loading = true;
        this.quote.status = STATUS.Submitted;
        this.$store.dispatch('homeInspector/createSlDisclosure');
      }

    },


    filters: {
      filterText(x) {
        if (x !== undefined) {
          if (x.indexOf("req") !== -1) {
            return "This field is required";
          } else {
            return x.replace("_", " ");
          }
        }
      }
    },

    mounted() {
      $('html, body').animate({
        scrollTop: $('.orep-header').offset().top
      }, 500);
    },

    components: {}
  };
</script>

<style scoped>
  strong {
    text-decoration: underline;
  }
  .form-inline > label {
    width: 82px;
    text-align: left;
  }
  .form-heading > p {
    font-size: 35px;
    width: 100%;
    text-align: center;
    margin: 0;
  }
  .form-errors,
  .js-input-errors {
    display: block;
    text-transform: initial;
    font-size: 13px;
    width: 90%;
    margin: auto;
    position: relative;
    top: -29px;
  }
  fieldset {
    font-size: 12px;
  }
  .logo {
    width: 150px;
    height: 45px;
    object-fit: contain;
  }
  h6 {
    font-size: 14px;
  }
  h5 {
    font-size: 16px;
  }
  .company-info-content {
    padding: 10px 30px;
    border: 1px solid black;
  }
  .fs-subtitle {
    margin: 20px 0;
    border-bottom: 2px solid black;
  }
  table.oreptable {
    font-size: 14px;
    margin-left: auto;
    margin-right: auto;
  }
  .gen-inf {
    display: flex;
    background: #eee none repeat scroll 0 0;
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 20px;
    margin-top: 20px;
    padding: 7px;
    text-align: left;
    height: 30px;
    border: 1px solid black;
  }
  .underline-value {
    margin-left: 10px;
    margin-right: 40px;
    border-bottom: 1px solid black;
    margin-bottom: 15px;
    font-weight: 700;
    font-size: 14px;
  }
  .table th, .table td {
    text-align: center;
    vertical-align: middle;
  }
  .table.ar td, .table.ar th {
    border-left: 1px solid #ddd !important;
    border-top: 1px solid #ddd !important;
    border-right: 1px solid #ddd !important;
  }
  .w-20 {
    width: 20%;
  }
  .blank_th {
    width: 210px;
  }
  .footer-company-info {
    background-color: yellow;
    border: 1px solid black;
    padding: 10px 20px 40px;
  }
  .form-check-input {
    position: relative;
    margin-left: 0;
  }
  .page-content p, .page-content li {
    font-size: 15px;
  }
  .p-56, .notice-list > li, .notice-info {
    padding-right: 56px;
  }
</style>

